/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LaundryUser } from './LaundryUser';
import {
    LaundryUserFromJSON,
    LaundryUserFromJSONTyped,
    LaundryUserToJSON,
} from './LaundryUser';
import type { Page } from './Page';
import {
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './Page';

/**
 * 
 * @export
 * @interface PageableLaundryUsers
 */
export interface PageableLaundryUsers {
    /**
     * 
     * @type {Array<LaundryUser>}
     * @memberof PageableLaundryUsers
     */
    result: Array<LaundryUser>;
    /**
     * 
     * @type {Page}
     * @memberof PageableLaundryUsers
     */
    page: Page;
}

/**
 * Check if a given object implements the PageableLaundryUsers interface.
 */
export function instanceOfPageableLaundryUsers(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function PageableLaundryUsersFromJSON(json: any): PageableLaundryUsers {
    return PageableLaundryUsersFromJSONTyped(json, false);
}

export function PageableLaundryUsersFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageableLaundryUsers {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(LaundryUserFromJSON)),
        'page': PageFromJSON(json['page']),
    };
}

export function PageableLaundryUsersToJSON(value?: PageableLaundryUsers | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(LaundryUserToJSON)),
        'page': PageToJSON(value.page),
    };
}

